import React, { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import EnterpriseContext from './Enterprise.context';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { BUSINESS_ROUTE } from 'data/global';
import FourDotLoader from 'components/FourDotLoader';
import api from 'api';
import useEnterpriseBrokers from 'hooks/useEnterpriseBrokers';
import useBusinessUnits from 'hooks/useBusinessUnits';
import useEnterprise from 'hooks/useEnterprise';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';

const EnterpriseProvider: React.FC = (props) => {
  const { children } = props;

  const { enterprise: userEnterprise, isSuperAdmin } =
    useContext(CurrentUserContext);

  const { enterpriseId } = useParams();

  const {
    enterprise,
    setEnterprise,
    updateEnterprise,
    updateBusinessUnits,
    updateMemberSeniorities,
    updateMemberLocations,
  } = useEnterprise(enterpriseId || userEnterprise?._id);
  const { popServerError } = useContext(PopNotificationsContext);

  const brokers = useEnterpriseBrokers(enterprise);
  const { businessUnitsOptions } = useBusinessUnits(enterprise?.businessUnits);

  const navigate = useNavigate();

  useEffect(() => {
    if (enterprise) return;

    if (!isSuperAdmin) {
      setEnterprise(userEnterprise);
      return;
    }

    (async () => {
      try {
        const { data } = await (enterpriseId
          ? api.enterprises.getEnterprise(enterpriseId)
          : api.enterprises.getBossModeRWC());

        setEnterprise(data);
      } catch (e) {
        popServerError(e);
        navigate(BUSINESS_ROUTE, { replace: true });
      }
    })();
  }, [
    isSuperAdmin,
    enterprise,
    userEnterprise,
    enterpriseId,
    navigate,
    popServerError,
    setEnterprise,
  ]);

  return (
    <EnterpriseContext.Provider
      value={{
        enterprise,
        units: businessUnitsOptions,
        brokers,
        updateEnterprise,
        updateBusinessUnits,
        updateMemberSeniorities,
        updateMemberLocations,
      }}
    >
      {enterprise ? children : <FourDotLoader />}
    </EnterpriseContext.Provider>
  );
};

export default EnterpriseProvider;
